const STREAMS = [
  {
    name: 'NETFLIX',
    path: 'https://www.netflix.com/search?q=',
  },
  {
    name: 'GAMATO',
    path: 'http://gamatotv2.com/?s=',
  },
  {
    name: 'FILMA24',
    path: 'https://www.filma24.ac/search/',
  },
];

export default STREAMS;